<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">智慧医院便民服务系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          在 “互联网 +” 浪潮下，智慧医院便民服务系统应运而生，旨在打破传统医疗服务的时空限制，为患者提供高效、便捷、贴心的全流程医疗服务。该系统依托先进的信息技术，深度整合医院资源，实现线上线下医疗服务的无缝对接，改善患者就医体验，提升医疗服务效率与质量。
        </p>
        <p class="content-paragraph">
          系统面向患者提供刷脸建档、健康卡管理、预约挂号、门诊缴费、信用就医、检查报告、药品配送、病案配送、预问诊、智能导诊、住院预缴、自助入院、患者满意度调查等全流程线上服务，并配套医院微站能力；面向医院提供账号体系、权限管理、数据统计、交易流水与系统设置等后台运营支撑，形成 “线上便民服务 + 后台精细运营” 的一体化体系。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">便民就医服务</h3>
            <ul class="capability-list"><li>预约挂号</li><li>门诊缴费</li><li>信用就医</li><li>住院预缴</li><li>自助入院</li><li>检查报告</li><li>在线退号</li><li>通知提醒</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">药品与病案配送</h3>
            <ul class="capability-list"><li>查询处方</li><li>配送下单</li><li>配送记录</li><li>物流跟踪</li><li>查询住院病案</li><li>通知提醒</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">智能服务与后台</h3>
            <ul class="capability-list"><li>智能导诊</li><li>智能问病</li><li>智能问药</li><li>预问诊</li><li>医院微站</li><li>数据统计</li><li>交易流水</li><li>权限管理</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/bm-home.svg"
              alt="海南华德科技有限公司 智慧医院便民服务系统 - 便民服务首页 · 一站式就医入口"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>便民服务首页 · 一站式就医入口
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/bm-register.svg"
              alt="海南华德科技有限公司 智慧医院便民服务系统 - 预约挂号 · 号源与医生选择"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>预约挂号 · 号源与医生选择
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/bm-payment.svg"
              alt="海南华德科技有限公司 智慧医院便民服务系统 - 门诊缴费 · 医保与信用结算"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>门诊缴费 · 医保与信用结算
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/bm-statistics.svg"
              alt="海南华德科技有限公司 智慧医院便民服务系统 - 数据统计 · 整体概况与交易流水"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>数据统计 · 整体概况与交易流水
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/software2.vue